import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Modal, Nav, Navbar, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaBell, FaCopy, FaLock, FaPenNib, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import ImgMarca from "../assets/img/marca-horizontal-cor.png";
import audioUrl from "../assets/sounds/efis-notification.mp3";
import appConfig from "../config/app.config";
import { AuthContext } from "../context/AuthContext";
import useApiClient, { apiRoutes } from "../hooks/apiClient";
import useSetGuard from "../hooks/useSetGuard";
import { signalrActions } from "../redux/signalr";

const Topbar = ({ history }) => {
  const { handleLogout, user, unreadNotifications, setUnreadNotifications, recuperarSenhaSigat } =
    useContext(AuthContext);
  const {
    assinaturaRequisitadaStateKey,
    filaAssinaturaStateKey,
    filaAssinaturaSucessoStateKey,
    filaAssinaturaFalhaStateKey,
  } = useSelector((state) => state.signalr);

  const { request, data } = useApiClient();
  const { request: requestAssinatura, data: dataAssinatura } = useApiClient();
  const dispatch = useDispatch();
  const [menu, setMenu] = useState([]);
  const [qtdAssinatura, setQtdAssinatura] = useState();
  const { request: requestMenu, data: dataMenu, errors: errorMenu } = useApiClient();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [sigatPassword, setSigatPassword] = useState("");
  const [loadingPassword, setLoadingPassword] = useState(false);
  // let notificationsItems = null;

  useEffect(() => requestAssinatura(apiRoutes.usuarios.arquivo.fila), [requestAssinatura, filaAssinaturaStateKey]);

  useEffect(() => {
    const usuario = JSON.parse(localStorage.getItem("user"));
    if (usuario) requestMenu(apiRoutes.usuarios.menu.consulta, usuario.permissoes);
  }, [requestMenu]);

  useEffect(() => {
    if (dataMenu) {
      setMenu(dataMenu.result.itens);
    }
  }, [dataMenu, errorMenu, menu]);

  function refreshPage() {
    window.parent.location = window.parent.location.href;
  }

  useEffect(() => {
    const viewUuid = uuid();

    request(apiRoutes.usuarios.notificacao.listar, {
      searchArgument: "EN",
      pageSize: 7,
      pageNumber: 1,
    });
    sessionStorage.setItem("viewUuid", viewUuid);

    if (!window.$ || !window.$.connection) {
      console.error("As dependências do SignalR não carregaram corretamente. ");
      return undefined;
    }

    const hub = window.$.connection.notificationsHub;

    hub.connection.url = `${process.env.REACT_APP_SIGNALR_HOST}/signalr`;
    hub.connection.appRelativeUrl = "/usuarios/signalr";

    hub.connection.qs = {
      clientId: appConfig.clientId,
      viewUuid,
      userKey: JSON.parse(localStorage.getItem("user")).userKey,
      clientName: "efis-web",
    };

    hub.on("sendNotification", (notification) => {
      const audio = new Audio(audioUrl);
      const newNotification = JSON.parse(notification);

      // Camada extra para evitar exposição indevida
      if (newNotification.userId !== JSON.parse(localStorage.getItem("user")).cnpjCpf) {
        return;
      }

      setUnreadNotifications((prevState) => [newNotification, ...prevState]);

      try {
        audio.play();
      } catch (e) {
        // Alguns browsers bloqueiam a execução antes da interação do usuário
        console.error(e);
      }
    });

    hub.on("remoteStateChanged", (state) => {
      /* Necessário adição de condições para diferenciar origem das chamadas de assinatura:
        // fila de assinaturas pendentes
        // assinatura em lote de SPF
        // assinatura em lote de OS
      */
      // Assinaturas Pendentens
      if (
        history.location.pathname !== "/app/spf/pendencias" &&
        history.location.pathname !== "/app/os/form" &&
        history.location.pathname !== "/app/os/spf/form/lote" &&
        history.location.pathname !== "/app/os/executarOs/consulta"
      ) {
        const payload = JSON.parse(state);
        dispatch(signalrActions.remoteStateChanged(payload));
      } else if (
        /* Assinaturas de SPF e OS */
        (history.location.pathname === "/app/spf/pendencias" ||
          history.location.pathname === "/app/os/executarOs/consulta" ||
          history.location.pathname !== "/app/os/gerarOs") &&
        state === JSON.stringify({ stateKey: "filaAssinaturaSucesso" })
      ) {
        if (history.location.pathname === "/app/spf/pendencias") {
          toast.success("Assinatura concluída com sucesso. ");
          refreshPage();
        } else {
          const payload = JSON.parse(state);
          dispatch(signalrActions.remoteStateChanged(payload));
        }
      } else if (
        /* quando receber retorno de falha nas assinaturas */
        (history.location.pathname === "/app/spf/pendencias" ||
          history.location.pathname !== "/app/os/executarOs/consulta" ||
          history.location.pathname !== "/app/os/gerarOs") &&
        state === JSON.stringify({ stateKey: "filaAssinaturaFalha" })
      ) {
        toast.error("Assinatura concluída com erros.");
        refreshPage();
      }
    });

    window.$.connection.hub.start();

    return () => {
      sessionStorage.removeItem("viewUuid");
      window.$.connection.hub.stop();
      console.warn("SignalR disconnected. ");
    };
  }, [dispatch, request, setUnreadNotifications, history]);

  useEffect(() => {
    if (data) setUnreadNotifications(data.result);
  }, [data, setUnreadNotifications]);

  const { guardLink, assinar } = useSetGuard();

  useEffect(() => {
    if (assinaturaRequisitadaStateKey) {
      assinar(assinaturaRequisitadaStateKey.arquivoInfo.SafePayload);
    }
    return () => {
      dispatch(signalrActions.clearState("assinaturaRequisitadaStateKey"));
    };
  }, [dispatch, assinar, assinaturaRequisitadaStateKey]);

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success("Assinatura concluída com sucesso. ", { toastId: filaAssinaturaSucessoStateKey });
      refreshPage();
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
      // refreshPage(); // TODO React19 refresh on destroy?
    };
  }, [dispatch, filaAssinaturaSucessoStateKey]);

  useEffect(() => {
    if (filaAssinaturaFalhaStateKey) {
      toast.error("Assinatura concluída com erros. ", { toastId: filaAssinaturaFalhaStateKey });
    }
    return () => {
      dispatch(signalrActions.clearState(filaAssinaturaFalhaStateKey));
    };
  }, [dispatch, filaAssinaturaFalhaStateKey]);

  const clickNotificacoesHandler = () => {
    history.push("/app/notificacoes");
  };

  const handleRecuperarSenha = async () => {
    setLoadingPassword(true);
    setShowPasswordModal(true);

    try {
      const senha = await recuperarSenhaSigat();
      setSigatPassword(senha);
    } catch (error) {
      setShowPasswordModal(false);
    } finally {
      setLoadingPassword(false);
    }
  };

  const handleCopiarSenha = () => {
    navigator.clipboard.writeText(sigatPassword);
    toast.success("Senha copiada para a área de transferência!");
  };

  const handleCloseModal = () => {
    setShowPasswordModal(false);
    setSigatPassword("");
  };

  // if (unreadNotifications.length) {
  //   notificationsItems = unreadNotifications.map((item) => (
  //     <NavDropdown.Item key={item.id} onClick={clickNotificacoesHandler}>
  //       <div className="text-left">{item.titulo}</div>
  //     </NavDropdown.Item>
  //   ));
  // } else {
  // notificationsItems = (
  //   <NavDropdown.Item href="#" onClick={clickNotificacoesHandler}>
  //     <div className="text-center">Nenhuma nova notificação. Ver todas...</div>
  //   </NavDropdown.Item>
  // );
  // }

  useEffect(() => {
    setQtdAssinatura(dataAssinatura?.result?.length);
  }, [qtdAssinatura, dataAssinatura?.result?.length]);

  return (
    <>
      {guardLink}
      <Navbar bg="white" expand="lg" className="mb-4 topbar shadow">
        <Navbar.Brand href="/app" className="ml-2 d-flex align-items-center">
          <img src={ImgMarca} height="40" className="d-inline-block" alt="efis logo" />
          <div id="topbar-brand-slogan" className="text-muted small text-truncate ml-3 d-none d-md-block">
            Sistema de Fiscalização da Secretaria de Fazenda do RN
          </div>
        </Navbar.Brand>

        <Nav className="d-lg-none ml-auto flex-row align-items-center">
          <div className="nav-item">
            <Nav.Link onClick={() => history.push("/app/assinatura")}>
              <span>
                <FaPenNib />
                <span className="badge badge-danger badge-counter">{qtdAssinatura || ""}</span>
              </span>
            </Nav.Link>
          </div>
          <div className="nav-item">
            <Nav.Link onClick={clickNotificacoesHandler}>
              <span>
                <FaBell />
                <span className="badge badge-danger badge-counter">{unreadNotifications.length || ""}</span>
              </span>
            </Nav.Link>
          </div>
          {/* <div className="nav-item">
            <Nav.Link onClick={handleRecuperarSenha}>
              <span>
                <FaLock />
              </span>
            </Nav.Link>
          </div> */}
        </Nav>

        <Navbar.Toggle aria-controls="topo" />
        <Navbar.Collapse id="topo">
          <Nav className="ml-auto">
            <div className="no-arrow d-none d-lg-block nav-item">
              <Nav.Link onClick={() => history.push("/app/assinatura")}>
                <span>
                  <FaPenNib />
                  <span className="badge badge-danger badge-counter">{qtdAssinatura || ""}</span>
                </span>
              </Nav.Link>
            </div>

            <div className="no-arrow d-none d-lg-block nav-item">
              <Nav.Link onClick={clickNotificacoesHandler}>
                <span>
                  <FaBell />
                  <span className="badge badge-danger badge-counter">{unreadNotifications.length || ""}</span>
                </span>
              </Nav.Link>
            </div>

            {/* <div className="no-arrow d-none d-lg-block nav-item">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-recuperar-senha">Recuperar Senha SIGAT</Tooltip>}
              >
                <Nav.Link onClick={handleRecuperarSenha}>
                  <span>
                    <FaLock />
                  </span>
                </Nav.Link>
              </OverlayTrigger>
            </div> */}

            {/* <NavDropdown
              className="no-arrow d-none d-lg-block"
              eventkey={0}
              title={
                <span>
                  <FaBell />
                  <span className="badge badge-danger badge-counter">{unreadNotifications.length || ""}</span>
                </span>
              }
            >
              {notificationsItems}
            </NavDropdown> */}

            <Nav.Link className="mt-1 d-none d-lg-block">
              <div className="topbar-divider d-none d-sm-block" />
            </Nav.Link>

            <Nav.Link className="d-lg-none ml-2 my-2" onClick={() => history.push("/app/home")}>
              <span>
                <i className="fas fa-home text-primary mx-2" />
              </span>
              <span className="ocultarNoToggle">Início</span>
            </Nav.Link>

            {menu.map((item, index) => {
              if (item.size) {
                return (
                  <Fragment key={item.title}>
                    <NavDropdown
                      className="d-lg-none"
                      eventkey={index}
                      title={
                        <span>
                          <span>
                            <i className={`${item.icon} text-primary mx-2`} />
                          </span>
                          <span className="ocultarNoToggle">{item.title}</span>
                        </span>
                      }
                    >
                      {item.itens.map((itemNivel1, indexNivel1) => (
                        <NavDropdown.Item
                          key={item.title}
                          eventkey={indexNivel1}
                          onClick={() => history.push(itemNivel1.url)}
                          className="px-5"
                        >
                          {itemNivel1.title}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  </Fragment>
                );
              }

              if (item.url) {
                return (
                  <Fragment key={item.title}>
                    <Nav.Item className="d-lg-none">
                      <OverlayTrigger placement="right" delay={{ show: 0, hide: 10 }}>
                        <Nav.Link eventkey={index} onClick={() => history.push(item.url)}>
                          <span>
                            <i className={item.icon} />
                          </span>
                          <span className="ocultarNoToggle">{item.title}</span>
                        </Nav.Link>
                      </OverlayTrigger>
                    </Nav.Item>
                  </Fragment>
                );
              }

              return null;
            })}
            <NavDropdown title={user.nome} icon={<FaUser />} className="dropdown small">
              <NavDropdown.Item href="#sair" onClick={handleLogout}>
                <FaSignOutAlt className="text-gray-500 mr-2" />
                &nbsp;Sair
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Modal show={showPasswordModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Senha SIGAT</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingPassword ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
            </div>
          ) : (
            <div>
              <p className="text-muted mb-2">Senha do usuário {user.nome}:</p>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={sigatPassword}
                  readOnly
                  style={{ fontFamily: "monospace", fontSize: "1.1rem" }}
                />
                <div className="input-group-append">
                  <Button variant="primary" onClick={handleCopiarSenha}>
                    <FaCopy /> Copiar
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Topbar;
